import PropTypes from 'prop-types';
import React from 'react';
import { GatewayDest } from 'react-gateway';
import Layout from './Layout';

const MainLayout = ({ children }) => (
  <Layout>
    <GatewayDest name="subtitle" className="u-show-for-large-and-up" />
    { children }
  </Layout>
);
MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;



// WEBPACK FOOTER //
// ./src/app/components/MainLayout.jsx